import { ReactNode } from 'react';

export interface MainLayoutSidebarProps {
  Content?: ReactNode;
}

const MainLayoutSidebar: React.FunctionComponent<MainLayoutSidebarProps> =
  function ({ Content }) {
    return (
      <div className="relative flex flex-col w-full max-h-full md:w-1/3 md:min-w-80 desktop:w-[calc(50%-240px)] bg-neutral-200 overflow-hidden">
        <div className="flex flex-col flex-1 max-h-full overflow-scroll">
          <div className="flex flex-col flex-1 w-full max-w-120 mx-auto md:ml-0">
            {Content}
          </div>
        </div>
      </div>
    );
  };

export default MainLayoutSidebar;
